import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { adminAPI } from '../../services/api';

function StudentList() {
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchStudents = useCallback(async () => {
        try {
            const response = await adminAPI.getStudents();
            setStudents(response.data);
        } catch (error) {
            toast.error('Failed to load students');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchStudents();
    }, [fetchStudents]);

    if (loading) {
        return <div className="loading">Loading students...</div>;
    }

    return (
        <div className="component-container">
            <h2>Registered Students ({students.length})</h2>

            <div className="students-table-container">
                <table className="students-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Category</th>
                            <th>Mini Project</th>
                            <th>Major Project</th>
                            <th>Registered</th>
                        </tr>
                    </thead>
                    <tbody>
                        {students.length === 0 ? (
                            <tr>
                                <td colSpan="6" className="empty-row">
                                    No students registered yet
                                </td>
                            </tr>
                        ) : (
                            students.map((student) => (
                                <tr key={student._id}>
                                    <td>{student.name}</td>
                                    <td>{student.email}</td>
                                    <td>
                                        <span className="category-badge">{student.category}</span>
                                    </td>
                                    <td>{student.assignedMiniProject?.name || 'N/A'}</td>
                                    <td>{student.assignedMajorProject?.name || 'N/A'}</td>
                                    <td>{new Date(student.createdAt).toLocaleDateString()}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default StudentList;
